module.exports = __webpack_public_path__ + "img/bg03.514dda6a.png";